var exports = {
  "jD": "x31de4314--7a7e98--breadcrumbs",
  "QX": "x31de4314--7a7e98--breadcrumbs-link",
  "Fg": "x31de4314--7a7e98--breadcrumbs-delimiter",
};

module.exports = exports;
